export default { tag: 'client@1.24.0' };
